import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Errors } from 'react-redux-form';
import { connect } from 'react-redux';
import get from 'lodash/get';
import _ from 'lodash';
import { getAccountOptsFromBankLinks, myIPOAccountID } from './utils';
import TransferFunds from '../Forms/TransferFunds';
import {
  baseTransferFundsPath,
} from '../Forms/Schemas/baseRrf';
import BaseDetailScreen from '../BaseDetailScreen';
import Button from '../Button';

import './styles.css';

import {
  fetchAccountBankLinks,
} from '../../actions/bankLinks';

import {
  transferFundsInfo,
} from '../../actions';
import { getConfigs } from '../../actions/configs';
import BaseModal from '../BaseModal';
import CloseIcon from '../../assets/images/close_gray.svg';

const Big = require('big.js/big.js');

class UnconnectedTransferFunds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferOpts: {},
      showBankTransferModal: false,
      bankTransferModalDisclaimer: null,
    };
  }

  componentDidMount() {
    this.props.fetchAccountBankLinks(this.props.accountNumber);
    this.props.getConfigs();
  }

  componentWillReceiveProps = (nextProps) => {
    const { accountBankLinks } = nextProps;
    const newOpts = getAccountOptsFromBankLinks(accountBankLinks);
    this.setState({
      transferOpts: newOpts,
    });
  }

  onSubmit = async () => {
    const formData = this.props.transferFundsForm;
    const { from, to } = formData.accounts;

    const { configs } = this.props;
    const bankLinkTransfer = _.find(configs, { configType: 'bank_transfer' });
    if (bankLinkTransfer && bankLinkTransfer.appConfig && bankLinkTransfer.appConfig.bankTransfer) {
      const {
        disabledInboundDisclaimerFunnel,
        disabledInboundFunnel,
        disabledOutboundDisclaimerFunnel,
        disabledOutboundFunnel,
      } = bankLinkTransfer.appConfig.bankTransfer;
      if (disabledInboundFunnel && to === myIPOAccountID) {
        this.setState({ bankTransferModalDisclaimer: disabledInboundDisclaimerFunnel, showBankTransferModal: true });
        return;
      }
      if (disabledOutboundFunnel && from === myIPOAccountID) {
        this.setState({ bankTransferModalDisclaimer: disabledOutboundDisclaimerFunnel, showBankTransferModal: true });
        return;
      }
    }
    const { transferOpts } = this.state;
    const data = {
      accounts: {
        From: from,
        To: to,
      },
      TransferAmount: Number.parseFloat(formData.transferAmount),
      fromLabel: transferOpts[from],
      toLabel: transferOpts[to],
    };
    await this.props.transferFundsInfo(data);
    this.props.onNext();
  }

  handleDisclaimerDialog = () => this.setState({ bankTransferModalDisclaimer: '', showBankTransferModal: false });

  render() {
    const {
      backTo,
      bankLinksFetching,
      cashBalance,
    } = this.props;
    const {
      transferOpts,
      showBankTransferModal,
      bankTransferModalDisclaimer,
    } = this.state;
    return (
      <BaseDetailScreen
        backLabel="Manage Account"
        backTo={backTo}
        pageHeading="Transfer Funds"
      >
        <div styleName="transferFunds">
          <Form
            onSubmit={this.onSubmit}
            model={baseTransferFundsPath}
            validators={{
              '': {
                accountsMatch: vals =>
                  vals.transferFunds.accounts.from !== vals.transferFunds.accounts.to,
                myIPOSelected: vals =>
                  vals.transferFunds.accounts.from === myIPOAccountID ||
                  vals.transferFunds.accounts.to === myIPOAccountID,
                fundsAvailable: (vals) => {
                  if (vals && vals.transferFunds.transferAmount &&
                  vals.transferFunds.accounts.from === myIPOAccountID) {
                    const bigAvail = new Big(cashBalance).round(2, 0);
                    const bigTransfer = new Big(vals.transferFunds.transferAmount);
                    return (bigAvail.gte(bigTransfer));
                  }
                  return true;
                },
                greaterThanZero: (vals) => {
                  if (vals && vals.transferFunds.transferAmount) {
                    const bigTransfer = new Big(vals.transferFunds.transferAmount);
                    return (bigTransfer.gt(0));
                  }
                  return true;
                },
              },
            }}
            disabled={bankLinksFetching}
          >
            <TransferFunds
              transferFundsPath=".transferFunds"
              bankOpts={transferOpts}
              disabled={bankLinksFetching}
              cashBalance={cashBalance}
            />
            <Errors
              styleName="errorText"
              component={props => <div>{props.children}</div>}
              show={form => form.touched || form.submitted}
              model={baseTransferFundsPath}
              messages={{
                  accountsMatch: 'Please select two different accounts for the transfer.',
                  myIPOSelected: 'My IPO must be selected as either the From or To account.',
                  fundsAvailable: 'Transfer Amount must be less than or equal to Cash Available.',
                  greaterThanZero: 'Transfer Amount must be greater than zero.',
                }}
            />
            <div styleName="submitBtn">
              <Button disabled={bankLinksFetching} type="submit">Review</Button>
            </div>
          </Form>
        </div>
        {showBankTransferModal && (
          <BaseModal onClose={() => this.handleDisclaimerDialog()}>
            <div styleName="dialogHeader">
              <button onClick={() => this.handleDisclaimerDialog()} type="button" styleName="dialogHeaderCloseBtn">
                <img width="12" src={CloseIcon} alt="icon" />
              </button>
            </div>
            <div styleName="dialogTitle">
              Notice
            </div>
            <div styleName="dialogText" style={{ textAlign: 'left' }}>
              <span>
                {bankTransferModalDisclaimer && bankTransferModalDisclaimer.split('\n').map(text => (<React.Fragment>{text}<br /></React.Fragment>))}
              </span>
            </div>
            <div styleName="dialogActions">
              <Button style={{ border: 'none', WebkitBoxShadow: 'none', boxShadow: 'none' }} onClick={() => this.handleDisclaimerDialog()}>
                Close
              </Button>
            </div>
          </BaseModal>
        )}
      </BaseDetailScreen>
    );
  }
}


UnconnectedTransferFunds.propTypes = {
  backTo: PropTypes.string,
  accountNumber: PropTypes.string,
};

UnconnectedTransferFunds.defaultProps = {
  backTo: '',
  accountNumber: 'unknown',
};

const mapStateToProps = (state, props) => ({
  accountBankLinks: get(state, `accountBankLinks.[${props.accountNumber}].data`, []),
  bankLinksFetching: get(state, `accountBankLinks.[${props.accountNumber}].isFetching`, false),
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[props.accountNumber], 'data.balanceAvailableForT1Trades', 0.00)),
  transferFundsForm: get(state, 'transferFundsForm.transferFunds'),
  configs: get(state, 'configs.data', []),
});

const mapDispatchToProps = {
  fetchAccountBankLinks,
  transferFundsInfo,
  getConfigs,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedTransferFunds);



// WEBPACK FOOTER //
// ./src/components/TransferFunds/TransferFunds.js